import { SvgIcon } from "@mui/material";

// Eye Icon
export function EyeIcon(props) {
  return (
    <SvgIcon
      sx={{ fill: "none" }}
      width="24px"
      height="24px"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        id="Iconly/Light/Show"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Show" transform="translate(2.000000, 4.000000)" stroke={props.color || "#000000"} strokeWidth="1.5">
          <path
            d="M13.1615,8.0531 C13.1615,9.7991 11.7455,11.2141 9.9995,11.2141 C8.2535,11.2141 6.8385,9.7991 6.8385,8.0531 C6.8385,6.3061 8.2535,4.8911 9.9995,4.8911 C11.7455,4.8911 13.1615,6.3061 13.1615,8.0531 Z"
            id="Stroke-1"
          />
          <path
            d="M9.998,15.3549 C13.806,15.3549 17.289,12.6169 19.25,8.0529 C17.289,3.4889 13.806,0.7509 9.998,0.7509 L10.002,0.7509 C6.194,0.7509 2.711,3.4889 0.75,8.0529 C2.711,12.6169 6.194,15.3549 10.002,15.3549 L9.998,15.3549 Z"
            id="Stroke-3"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
